import React, { useContext } from 'react'
import Button from 'Lib/Buttons'
import PageLoader from 'Lib/Pageloader'
import { AccountsContext } from 'AccountsContext'

import DesktopModal from '../DesktopModal/DesktopModalPWA'
import CaseHistoryCards from './CaseHistoryCards'
import SupportWidget from '../../components/Support/SupportWidget'

const CaseHistoryDesktopModal = props => {
  const { toggleModal, setToggleModal, caseData, tripId, isPWA,
    setRefetchCases, refetchCases, verticalName } = props
  const { openModal } = useContext(AccountsContext)

  const openSupportModal = e => {
    openModal()
    setToggleModal(false)
  }

  return (
    <React.Fragment>
      <DesktopModal
        showFlag={toggleModal}
        onCloseModal={() => {
          setToggleModal(false)
        }}
        header="Trip support requests"
      >
        <If condition={refetchCases}>
          <PageLoader className={`${isPWA ? '' : 'modal-loader'}`} title="Fetching Case Details" message="Please wait while we are updating case details." />
          <Else />
          <CaseHistoryCards
            tripId={tripId}
            caseData={caseData}
            isPWA={isPWA}
            setRefetchCases={setRefetchCases}
          />
          <div className="p-8">
            <Button
              full={true}
              outline={true}
              size="lg"
              type="secondary"
              className="tt-sentence fs-16 amr-10 w-100p h-10"
              onClick={e => { openSupportModal(e) }}
            >
        Raise a new request
            </Button>
          </div>
          <SupportWidget setRefetchCases={setRefetchCases} verticalName={verticalName} />
        </If>
      </DesktopModal>
    </React.Fragment>
  )
}
export default CaseHistoryDesktopModal
